import React, { useState, useEffect } from "react";
import ImageModal from "./ImageModal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const Vendorkyc = () => {
  // ====================modal====================

  const [vendorkyc, updateKyc] = useState([]);
  const baseurl = `https://apimlm.bloomitsolutions.in`;

  

  // ===================calling form ====================

  // Sample data (you can replace this with your actual data)
  const getkyc = async () => {
    try {
      const response = await fetch(
        "https://apimlm.bloomitsolutions.in/vendorroutes/getAllkyc"
      );
      if (response.ok) {
        const data = await response.json();
        updateKyc(data.reverse());
        console.log("errrrrrrrrrrr", data);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getkyc();
  }, []);

  const navigate = useNavigate();

  const handleAllKycClick = (e) => {
    e.preventDefault();
    navigate("/User");
  };

  const handlePendingKycClick = (e) => {
    e.preventDefault();
    navigate("/Vendor");
  };

  const updateKycStatus = (vendorId, status) => {
    const updatedKyc = vendorkyc.map((kycData) =>

      
      kycData.vendorId === vendorId ? { ...kycData, status } : kycData

      
    );
    updateKyc(updatedKyc);
    
  };

  console.log("userrrid", vendorkyc);

  const acceptKyc = (vendorId) => {
   
    axios.put(`https://apimlm.bloomitsolutions.in/vendorroutes/verifyKYC?vendorId=${vendorId}`,{
      "isKYCVerified": true
    })
   
    updateKycStatus(vendorId, "Approved");
    toast(vendorId+"Approved Successfully");
   
  };

  const declineKyc = (vendorId) => {
    
    updateKycStatus(vendorId, "Declined");
    toast(vendorId+"Declined Successfully");
    
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState("");
  
  
  const openImageModal = (imageUrl) => {
      setEnlargedImageUrl(imageUrl);
      setShowImageModal(true);
    };
    
    const closeImageModal = () => {
      setEnlargedImageUrl("");
      setShowImageModal(false);
    };


  return (
    <section>
      <div className="container-fluid ">
      <ToastContainer/>
        <div className="row">
          <div className="col-lg-12">
            <button className="mt-4 btn btn-white" onClick={handleAllKycClick}>
              User KYC
            </button>
            {""}

            <button
              className="mt-4 btn btn-white"
              onClick={handlePendingKycClick}
            >
              Vendor KYC
            </button>

            <div className="card mt-4">
              <div className="card-header bg-primary text-white">
                <h4> Vendor KYC</h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table
                    id="example"
                    className="table table-bordered border-t0 key-buttons text-nowrap w-100"
                  >
                    <thead>
                      <tr>
                        <th>Sl.No</th>
                        <th>Pan Card</th>
                        <th>Aadhaar Card Front Image</th>
                        <th>Aadhaar Card Back Image</th>
                        <th>Cancel Cheque Or Bank PassBook Front Page Image</th>
                        <th>Status</th>
                        <th>Action</th>
                        <th>Reconsider</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vendorkyc.map((kycData) => (
                        <tr key={kycData.id}>
                          <td>{kycData.id}</td>
                          <td>
                            <img
                              src={`${baseurl}/${kycData.pancardImages}`}
                              className="img-fluid"
                                  style={{
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                  }}
                                  onClick={() => openImageModal(`${baseurl}/${kycData.pancardImages}`)}
                            />
                          </td>
                          <td>
                            <img
                              src={`${baseurl}/${kycData.adharFrontImage}`}
                              className="img-fluid"
                                  style={{
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                  }}
                                  onClick={() => openImageModal(`${baseurl}/${kycData.adharFrontImage}`)}
                            />
                          </td>
                          <td>
                            <img
                              src={`${baseurl}/${kycData.adharBackImage}`}
                              className="img-fluid"
                                  style={{
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                  }}
                                  onClick={() => openImageModal(`${baseurl}/${kycData.adharBackImage}`)}
                            />
                          </td>
                          <td>
                            <img
                              src={`${baseurl}/${kycData.bankPassbookImage}`}
                              className="img-fluid"
                                  style={{
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                  }}
                                  onClick={() => openImageModal(`${baseurl}/${kycData.bankPassbookImage}`)}
                            />
                          </td>
                          <td>{kycData.status}</td>
                          <td>
                            {kycData.status !== 'Declined' && (
                              <button
                                className="btn btn-success mx-2"
                                onClick={() => acceptKyc(kycData.vendorId)}
                              >
                                Approve
                              </button>
                            )}
                            {kycData.status !== 'Approved' && (
                              <button
                                className="btn btn-danger mx-2"
                                onClick={() => declineKyc(kycData.vendorId)}
                              >
                                Decline
                              </button>
                            )}
                          </td>


                          <td>
                            {kycData.status === 'Pending' ? (
                              <button
                                className="btn btn-warning mx-2"
                              >
                                Reconsider
                              </button>
                            ) : (
                              <div>
                                {kycData.status === 'Approved' ? (
                                  <button
                                    className="btn btn-danger mx-2"
                                    onClick={() => declineKyc(kycData.vendorId)}
                                  >
                                    Decline
                                  </button>
                                ) : kycData.status === 'Declined' ? (
                                  <button
                                    className="btn btn-success mx-2"
                                    onClick={() => acceptKyc(kycData.vendorId)}
                                  >
                                    Approve
                                  </button>
                                ) : (
                                  <div>
                                    <button
                                      className="btn btn-success mx-2"
                                      onClick={() => acceptKyc(kycData.vendorId)}
                                    >
                                      Approve
                                    </button>
                                    <button
                                      className="btn btn-danger mx-2"
                                      onClick={() => declineKyc(kycData.vendorId)}
                                    >
                                      Decline
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showImageModal && (
  <ImageModal
    isOpen={showImageModal}
    onRequestClose={closeImageModal}
    imageUrl={enlargedImageUrl}
  />
)}
    </section>
  );
};

export default Vendorkyc;